export const LANDING = '/';
export const CONTACT = '/contact';
export const ABOUT = '/about';
export const GALLERY = '/gallery';
export const CAUSES = '/causes';
export const CAUSESDETAILS = '/causes/:id';

export const BLOG = '/blog/posts';
export const BLOGDETAILS = '/blog/posts/:id';
export const CATEGORY_BLOG_POSTS = '/blog/:category/posts';
export const FAQ = '/faq';
export const TEAM = '/team/details';
export const BECOME_VOLUNTEER = '/become-volunteer';

// Auth routes
export const LOGIN = '/auth/login';
export const REGISTER = '/auth/register';
export const FORGOT_PASSWORD = '/auth/forgot-password';
export const RESET_PASSWORD = '/auth/reset-password';

export const NOTFOUND = '*';
